import { Injectable, inject } from '@angular/core';
import { InvestigationAuthorizationState } from '../../states/investigation-authorization.state';
import { InvestigationRole } from '../../../domain/enums/investigation-role.enum';

/**
 * Use case for reading the current user's investigation role.
 * Returns null if the authorization state has not been loaded yet.
 */
@Injectable({ providedIn: 'root' })
export class GetInvestigationRoleUseCase {
  private readonly state = inject(InvestigationAuthorizationState);

  public execute(): InvestigationRole | null {
    return this.state.role();
  }
}
